import { useEffect, useState } from 'react';

/** True once `active` has stayed true for `delayMs`, false as soon as it turns false. */
function useDelayedFlag(active: boolean, delayMs: number): boolean {
  const [elapsed, setElapsed] = useState(false);

  useEffect(() => {
    if (!active) return;

    const id = setTimeout(() => setElapsed(true), delayMs);
    return () => {
      clearTimeout(id);
      setElapsed(false);
    };
  }, [active, delayMs]);

  return active && elapsed;
}

export default useDelayedFlag;
